/* RESPONSIBLE TEAM: team-ai-agent-2 */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';
import type RouterService from '@ember/routing/router-service';
import type AppService from 'embercom/services/app-service';
import type Transition from '@ember/routing/transition';

interface ValidatePermissionsResponse {
  missing_permission?: string;
}

const PREVIEW_INDEX_ROUTE = 'apps.app.automation.fin-ai-agent.procedures.procedure.preview.index';

class AutomationFinAIAgentProcedureSimulationsRoute extends Route {
  @service declare router: RouterService;
  @service declare appService: AppService;
  @service declare permissionsService: $TSFixMe;

  reactEnabled() {
    return true;
  }

  async beforeModel(transition: Transition) {
    let appId = this.appService.app.id;

    try {
      let response = await fetch(
        `/teammate_app/sophisticated_tests/validate_permissions?app_id=${appId}`,
      );

      if (response.ok) {
        return;
      }

      if (response.status === 403) {
        let responseData = (await response.json()) as ValidatePermissionsResponse;
        let missingPermission = responseData.missing_permission;

        // External AI consent is handled by the template component, allow navigation
        if (missingPermission === 'external_ai_consent') {
          return;
        }

        // For can_access_contacts or can_access_user_profiles, show permission modal
        if (missingPermission) {
          await this.permissionsService.cancelTransitionAndShowPermissionModal(
            missingPermission,
            transition,
            PREVIEW_INDEX_ROUTE,
          );

          if (transition.from?.name) {
            this.router.transitionTo(transition.from.name);
          }

          return;
        }
      }

      // Non-403 error status, redirect to preview
      this.router.transitionTo(PREVIEW_INDEX_ROUTE);
    } catch (e: unknown) {
      // Network or parsing error - redirect to preview as fallback
      this.router.transitionTo(PREVIEW_INDEX_ROUTE);
    }
  }
}

export default ReactRoute(AutomationFinAIAgentProcedureSimulationsRoute, {
  overrideRenderTemplate: false,
});
